/* Süti — add-on rows inside the cart drawer.

   All the matching and running-order logic is in
   snippets/suti-drawer-addon.liquid and runs server-side on every cart update.
   The only thing left for the client is the tick, so this file stays small.

   TICKING IS ADDING. On the PDP the checkbox only decides what rides along with
   the add-to-cart button. There is no such button in the drawer, so the box has
   to act on the cart directly.

   A row never arrives ticked: the snippet drops an add-on from the block once it
   is in the cart, so every row rendered is an offer the shopper has not taken.
   The untick branch below is therefore reached only in the moment between the
   optimistic paint and the re-render that removes the row — a double tap, or
   space pressed twice. It stays because that window is real and leaving the box
   ticked with nothing added would be a lie; the busy flag keeps it to one
   request at a time.

   EVERYTHING HERE IS SCOPED TO THE ROW, NOT THE BLOCK. The drawer can render
   two add-on rows in one block. Reading the row off the block would find the
   first one whichever was clicked, and a busy flag held on the block would lock
   both rows while either was in flight. Both are keyed to the clicked row.

   THE LISTENERS ARE DELEGATED FROM document ON PURPOSE. Changing the cart
   re-renders the drawer, which replaces the row that was clicked — and a
   <script> that arrives inside that re-rendered HTML never executes. Handlers
   bound to the row itself would work exactly once per page load.

   ASKING FOR `sections` IS WHAT REDRAWS THE DRAWER. The theme's drawer renders
   from section HTML handed to it on the cart:update event; without the sections
   key and the dispatch below, the cart changes but the drawer keeps showing
   stale contents. */
(function () {
  'use strict';

  if (window.__sutiDrawerAddonBound) return;
  window.__sutiDrawerAddonBound = true;

  /* THE VISITOR'S BUCKET.

     When both universal add-ons compete for one slot the snippet renders both,
     tagged data-bucket 0 and 1, and the stylesheet hides whichever this visitor
     is not in. The decision has to live on the client because Liquid has no
     per-visitor entropy — see the snippet's header for the two server-side
     seeds that were tried and why each turned out to be a constant.

     Written to <html>, which the drawer re-render does not replace, so the
     assignment holds for the whole visit. Stored so it also holds across
     navigation and return visits, which is what makes the split worth reading.
     localStorage throws in some privacy modes; the catch leaves the attribute
     set for this page view, and the stylesheet's default covers it being
     absent. */
  try {
    var KEY = 'suti:addon-bucket';
    var bucket = null;
    try {
      bucket = window.localStorage.getItem(KEY);
    } catch (e) {}
    if (bucket !== '0' && bucket !== '1') {
      bucket = Math.random() < 0.5 ? '0' : '1';
      try {
        window.localStorage.setItem(KEY, bucket);
      } catch (e) {}
    }
    document.documentElement.setAttribute('data-suti-addon-bucket', bucket);
  } catch (e) {
    console.error('[suti-drawer-addon] bucket', e);
  }

  var ADD = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
  var CHANGE = (window.Theme && Theme.routes && Theme.routes.cart_change_url) || '/cart/change';

  function cartSectionIds() {
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component'), function (node) {
      var id = node.dataset && node.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids.join(',');
  }

  function withSections(body) {
    body.sections_url = window.location.pathname;
    var sections = cartSectionIds();
    if (sections) body.sections = sections;
    return body;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(withSections(body)),
    }).then(function (response) {
      return response.json();
    });
  }

  function apply(checkbox) {
    var row = checkbox.closest('.sao__row');
    var variantId = Number(checkbox.getAttribute('data-suti-drawer-cb'));
    if (!variantId || !row || row.dataset.busy === '1') return;

    /* Paint the new state straight away. The round trip is fast but not
       instant, and a checkbox that lags behind the finger feels broken. */
    row.classList.toggle('is-on', checkbox.checked);
    row.dataset.busy = '1';

    var wanted = checkbox.checked;
    var request = wanted
      ? post(ADD, { items: [{ id: variantId, quantity: 1 }] })
      : post(CHANGE, { id: String(variantId), quantity: 0 });

    request
      .then(function (data) {
        row.dataset.busy = '0';
        if (data && data.status) {
          /* Shopify refused it — sold out, or not sellable in this market.
             Put the control back where it was rather than leave it lying. */
          checkbox.checked = !wanted;
          row.classList.toggle('is-on', checkbox.checked);
          return;
        }
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: 'suti-drawer-addon',
              data: {
                source: 'suti-drawer-addon',
                itemCount: wanted ? 1 : 0,
                variantId: String(variantId),
                sections: data && data.sections,
              },
            },
          })
        );
      })
      .catch(function (error) {
        console.error('[suti-drawer-addon]', error);
        row.dataset.busy = '0';
        checkbox.checked = !wanted;
        row.classList.toggle('is-on', checkbox.checked);
      });
  }

  /* Anywhere on the row toggles, as on the PDP — except the Learn More link,
     which has to stay a link. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;

    var row = target.closest('[data-suti-drawer-addon] .sao__row');
    if (!row) return;
    if (target.closest('a')) return;

    var checkbox = row.querySelector('.sao__cb');
    if (!checkbox) return;

    /* The checkbox is visually hidden but still focusable; when the click
       landed on it the browser has already flipped it and will fire change. */
    if (target === checkbox) return;

    event.preventDefault();
    checkbox.checked = !checkbox.checked;
    apply(checkbox);
  });

  /* Keyboard: space on the focused checkbox fires change without a click. */
  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest && event.target.closest('[data-suti-drawer-addon] .sao__cb');
    if (checkbox) apply(checkbox);
  });
})();
